<template>

  <ModalContainer queryParam="psi" ref="modalContainer" size="xl">
    <b-card>
      <h3 class="modal-title mb-1">Informe de la Terapia Psicológica.</h3>

      <b-row>
        <b-col class="col-12">
          <b-card bg-variant="light" text-variant="dark">
            <b-col class="col-6">
              <b-row class="mb-1">
                <b class="col-4">Paciente: </b>{{ dataTerapia.pacienteNombre }}
              </b-row>


              <b-row class="mb-1">
                <b class="col-4">Nombre de terapia:</b>
                <span class="col-7 p-0">{{ dataTerapia.nombre }}</span>
              </b-row>

              <b-row class="mb-1">
                <b class="col-4">Fecha de sesion:</b>
                <span class="col-7 p-0">{{ dataTerapia.fechaSesion }}</span>
              </b-row>

            </b-col>
              <b-col class="col-6">
              <b-row class="mb-1">
                <b class="col-4">Motivo Solicitud: </b>{{ dataTerapia.motivoSolicitud }}
              </b-row>


              <b-row class="mb-1">
                <b class="col-4">Resumen/Plan Terapeutico:</b>
                <span class="col-7 p-0">{{ dataTerapia.resumenClinico }}</span>
              </b-row>

             

            </b-col>
          </b-card>
        </b-col>

      </b-row>


      <b-tabs>
        <b-tab title="Examen Fisico">
          <b-card style="border:1px solid #c9c9c9" class="py-2">

            <div class="row">

              <div class="col-12 d-flex align-items-center">
                <label class=""> Estatura: </label>
                <b-form-input v-model="examenFisico.estatura" type="number" class="col-1 mx-2" />
              </div>

              <div class="col-6">

                <div class="my-1">
                  <label>Color de Piel:</label>

                  <v-select placeholder="Seleccione o ingrese una opcion" :options="colorPielOpts"
                    v-model="examenFisico.colorPiel" :reduce="option => option" label="text" taggable
                    @input="newArray => examenFisico.colorPiel = onAddUniqueNewOpt(newArray)" />
                </div>


                <div class="my-1">
                  <label>Contextura Corporal:</label>

                  <v-select placeholder="Seleccione o ingrese una opcion" :options="contexturaOpts"
                    v-model="examenFisico.contextura" :reduce="option => option" label="text" taggable
                    @input="newArray => examenFisico.contextura = onAddUniqueNewOpt(newArray)" />
                </div>

                <div class="my-1">
                  <label>Vestimenta:</label>

                  <v-select placeholder="Seleccione o ingrese una opcion" :options="vestimentaOpts"
                    v-model="examenFisico.vestimenta" :reduce="option => option" label="text" taggable
                    @input="newArray => examenFisico.vestimenta = onAddUniqueNewOpt(newArray)" />
                </div>

              </div>

              <div class="col-6">
                <div class="my-1">
                  <label>Actitud:</label>

                  <v-select placeholder="Seleccione o ingrese una opcion" :options="actitudOpts"
                    :reduce="option => option" label="text" taggable
                    @input="newArray => examenFisico.actitud = onAddUniqueNewOpt(newArray)" />
                </div>


                <div class="my-1">
                  <label>Animo:</label>

                  <v-select placeholder="Seleccione o ingrese una opcion" :options="animoOpts"
                    :reduce="option => option" label="text" taggable
                    @input="newArray => examenFisico.animo = onAddUniqueNewOpt(newArray)" />
                </div>


                <div class="my-1">
                  <label> ¿Se está medicando? : </label>

                  <div class="d-flex align-items-center my-1 ml-1">
                    <label for="">{{ examenFisico.seMedica ? 'Si' : 'No' }}</label>
                    <b-form-checkbox v-model="examenFisico.seMedica" switch class="ml-1" />
                  </div>


                  <b-form-group v-if="examenFisico.seMedica"
                    label="Describa detalles sobre el medicamento y su administración: " class="mt-1">
                    <b-form-textarea v-model="examenFisico.semedicaDesc" />
                  </b-form-group>
                </div>
              </div>
            </div>

          </b-card>

        </b-tab>


        <b-tab title="Examen Mental" active>
          <b-card style="border:1px solid #c9c9c9">

            <div class="row">

              <div class="mt-1 col-lg-6">
                <label> Apariencia General: </label>
                <b-form-textarea v-model="examenMental.aparienciaGeneral" />
              </div>

              <div class="mt-1 col-lg-6">
                <label> Asociación, Flujo de Ideas</label>
                <b-form-textarea v-model="examenMental.asociacionFlujoIdeas" />
              </div>

              <div class="mt-1 col-lg-6">
                <label> Estado de conciencia: </label>
                <b-form-textarea v-model="examenMental.estadoDeConciencia" />
              </div>

              <div class="mt-1 col-lg-6">
                <label> Pensamiento: </label>
                <b-form-textarea v-model="examenMental.pensamiento" />
              </div>

              <div class="mt-1 col-lg-6">
                <label> Contenido de ideas: </label>
                <b-form-textarea v-model="examenMental.contenidoDeIdeas" />
              </div>

              <b-col class="mt-1 col-lg-6">
                <label> Memoria: </label>
                <b-form-textarea v-model="examenMental.memoria" />
              </b-col>

              <b-col class="col-12 my-1">
                <label> Resultado del Examen: </label>
                <b-form-textarea v-model="examenMental.resultadoDelExamen" />
              </b-col>

            </div>

          </b-card>
        </b-tab>



        <b-tab title="Procedimiento / Plan Terapeutico">

          <div class="row">

            <div class="my-1 col-6">
              <label for="">Procedimiento aplicado:</label>
              <b-form-input v-model="procPlanTerap.procedimientoAplicado"
                placeholder="Ingrese el procedimiento aplicado" />
            </div>

            <div class="my-1 col-6">
              <label for="">Antecedentes Personales:</label>
              <v-select class="p-0" placeholder="Seleccione o ingrese una opcion" :options="antPersonalesOpts"
                v-model="procPlanTerap.antPersonales" :reduce="option => option" label="text" taggable multiple
                @input="newArray => procPlanTerap.antPersonales = onAddNewOpt(newArray)" />

              <div v-if="procPlanTerap.antPersonales.length > 0">
                <label for="">Descripcion del antecedente:</label>
                <b-form-input v-model="procPlanTerap.antPersonalesDesc" />
              </div>

            </div>



            <div class="my-2 col-6">
              <label for="">Evolucion Actual:</label>
              <b-form-textarea id="medidasgen" v-model="procPlanTerap.evolucionActual"
                placeholder="Medidas generales a considerar..." rows="2" class="form-control" />
            </div>


            <div class="my-1 col-6">
              <label for="">Perfil Social:</label>
              <v-select class="p-0" placeholder="Seleccione o ingrese una opcion" :options="perfilSocialOpts"
                v-model="procPlanTerap.perfilSocial" :reduce="option => option" label="text" taggable multiple
                @input="newArray => procPlanTerap.perfilSocial = onAddNewOpt(newArray)" />

              <div v-if="procPlanTerap.perfilSocial.length > 0">
                <label for="">Descripcion del perfil social:</label>
                <b-form-input v-model="procPlanTerap.perfilSocialDesc" />
              </div>

            </div>


            <div class="my-1 col-6">
              <label for="">Plan Terapeutico:</label>
              <b-form-textarea id="plantera" v-model="procPlanTerap.planTerapeutico"
                placeholder="Describa el plan terapéutico aquí..." rows="2" class="form-control" />
            </div>

            <div class="my-1 col-6">
              <label for="">Conclusion de la sesion de la terapia:</label>
              <b-form-textarea id="plantera" v-model="procPlanTerap.conclusion" placeholder="Conclusion" rows="2"
                class="form-control" />
            </div>

          </div>

        </b-tab>

       <b-tab title="Firma Paciente">
             <ProcessSignature  :base64Signature="dataTerapia.signatureBlob"
            @signatureBlob="firmaRecibida" />
       </b-tab>
      </b-tabs>


      <div class="d-flex justify-content-end">
        <b-button variant="primary" @click="onSaveFormSesion">
          Guardar
        </b-button>
      </div>


    </b-card>
  </ModalContainer>

</template>

<script>
import vSelect from "vue-select";
import { addNewOpt, addUniqueNewOpt } from '@/shared/helpers';
import 'flatpickr/dist/flatpickr.css';
import { sesionesTerapiaService } from "../services";
import ProcessSignature from "../../topaz/components/ProcessSignature.vue";


import { ModalContainer } from '@/shared/components';

export default {
  name: "FormTerapiaPsicologica",


  components: {
    vSelect,
    ModalContainer,
    ProcessSignature
  },


  data() {
    return {
      sesionesTerapiaService,
      tokenSesion: null,
      tokenTerapia: null,

      dataTerapia: {
        pacienteNombre: '',
        nombre: '',
        fechaSesion: '',
        motivoSolicitud: '',
        resumenClinico: '',
        signaturePersona: null,
        signatureBlob: null,
      },
      nuevaFirma : '',

      terapia: {
        fechaProgramada: null,
      },

      examenFisico: {
        estatura: 0,
        colorPiel: null,
        contextura: null,
        vestimenta: null,
        actitud: null,
        animo: null,
        seMedica: false,
        seMedicaDesc: '',
      },

      examenMental: {
        aparienciaGeneral: null,
        asociacionFlujoIdeas: null,
        estadoDeConciencia: null,
        pensamiento: null,
        memoria: null,
        contenidoDeIdeas: null,
        resultadoDelExamen: null
      },

      procPlanTerap: {
        procedimientoAplicado: null,
        evolucionActual: null,
        planTerapeutico: null,
        antPersonales: [],
        antPersonalesDesc: '',
        perfilSocial: [],
        perfilSocialDesc: '',
        conclusion: null
      },

      antPersonalesOpts: [
        { value: "1", text: "Problemas psicológicos del pasado" },
        { value: "2", text: "Alimentación" },
        { value: "3", text: "Hábitos del sueño" },
      ],

      perfilSocialOpts: [
        { text: "Padres", value: "padres" },
        { text: "Hijos", value: "hijos" },
        { text: "Hermanos", value: "hermanos" },
        { text: "Familiares", value: "familiares" },
        { text: "Amigos", value: "amigos" },
        { text: "Amorosos", value: "amorosos" },
        { text: "Laboral", value: "laboral" },
        { text: "Otros", value: "otros" },
      ],


      colorPielOpts: [
        { value: "blanca", text: "Blanca" },
        { value: "morena", text: "Morena" },
        { value: "mestizo", text: "Mestizo" },
      ],

      contexturaOpts: [
        { value: "ectomorfo", text: "Ectomorfo" },
        { value: "mesomorfo", text: "Mesomorfo" },
        { value: "endomorfo", text: "Endomorfo" },
        { value: "ectomesomorfo", text: "Ectomesomorfo" },
        { value: "endomesomorfo", text: "Endomesomorfo" }
      ],

      vestimentaOpts: [
        { value: "extravagante", text: "Extravagante" },
        { value: "desalinado", text: "Desaliñado" },
        { value: "pulcro", text: "Pulcro" },
        { value: "modesto", text: "Modesto" },
        { value: "ropa_oscura", text: "Ropa oscura" }
      ],

      actitudOpts: [
        { value: "positiva", text: "Positiva" },
        { value: "negativa", text: "Negativa" },
        { value: "proactiva", text: "Proactiva" },
        { value: "reactiva", text: "Reactiva" }
      ],

      animoOpts: [
        { value: "alegre", text: "Alegre" },
        { value: "triste", text: "Triste" },
        { value: "irritable", text: "Irritable" },
        { value: "ansioso", text: "Ansioso" },
        { value: "calmado", text: "Calmado" },
        { value: "euforico", text: "Eufórico" },
        { value: "desanimado", text: "Desanimado" },
        { value: "agitado", text: "Agitado" }
      ]

    };
  },

  // created() {
  //   this.loadData();
  // },

  watch:{

    '$route.query.psi':
    {
      deep:true,
      immediate:true,
      async handler(newValue){
        if(newValue){
          await this.loadData()
        }
      }
    }
  },

  methods: {
      firmaRecibida(blob) {
      this.nuevaFirma = blob;
    },


    async loadData() {


      this.tokenSesion = this.$route.query.psi;

      const dataResponse = await this.sesionesTerapiaService.obtenerDataSesionTerapia(this.tokenSesion)
      const sesionTerapia = dataResponse.sesionTerapia
      const paciente = dataResponse.paciente
      this.dataTerapia.pacienteNombre = `${paciente.persona.primerApellido} ${paciente.persona.primerNombre}`
      this.dataTerapia.nombre = sesionTerapia.solicitudTerapia.terapia.nombre
      this.dataTerapia.fechaSesion = sesionTerapia.fechaSesion
      this.dataTerapia.motivoSolicitud = sesionTerapia.solicitudTerapia.motivoSolicitud
      this.dataTerapia.resumenClinico = sesionTerapia.solicitudTerapia.resumenClinico


      try{
        if(dataResponse){
          
          let dataForm = JSON.parse(dataResponse.sesionTerapia.dataFormulario)
          this.examenFisico = dataForm.examenFisico
          this.examenMental = dataForm.examenMental
          this.procPlanTerap = dataForm.procPlanTerap
        }
      }catch(error){
        console.error("error parseo", error)
      }

    },



    async onSaveFormSesion() {

      let dataForm = {
        examenFisico: this.examenFisico,
        examenMental: this.examenMental,
        procPlanTerap: this.procPlanTerap,
        firmaBlob: this.nuevaFirma ? this.nuevaFirma : ''
      }

      const jsonDataForm = JSON.stringify(dataForm)
      const response = await this.sesionesTerapiaService.saveDataSesionTerapia(this.tokenSesion, jsonDataForm)

      if (response) {
        // Cerrar el modal al guardar correctamente
        if (this.$refs.modalContainer && this.$refs.modalContainer.closeModal) {
          await this.$refs.modalContainer.closeModal();
        }
        this.$swal.fire({
          icon: 'success',
          title: 'Datos guardados',
          text: 'La sesión de terapia se guardó correctamente.',
          confirmButtonText: 'Aceptar'
        });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'Error al guardar',
          text: 'No se pudo guardar la sesión de terapia. Por favor, intenta de nuevo.',
          confirmButtonText: 'Cerrar'
        });

      }
    },


    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

    onAddUniqueNewOpt(newArray) {
      return addUniqueNewOpt(newArray);
    },
  }
}
</script>
